var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showConsentBanner ? _c('div', {
    staticClass: "consent-banner"
  }, [_c('ThemedLoading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false
    }
  }), _c('div', [_c('p', {
    staticClass: "consent-banner-description"
  }, [_vm._v(" " + _vm._s(_vm.$t("marketingConsent")) + " ")]), _c('div', {
    staticClass: "consent-banner-actions"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function () {
        return _vm.onButtonClick('disagree');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Disagree")) + " ")]), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function () {
        return _vm.onButtonClick('agree');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Agree")) + " ")])])])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }